<div class="navbar-toolbar-content-container">
  <h3 class="mobile-navigation-title">
    {{ navbarToolbarContentService.mobileNavigationTitle$ | async }}
  </h3>
  <div class="trial-message" *ngIf="navbarToolbarContentService.displaySignatureMessage$ | async">
    <mat-icon color="warn" class="warning-icon">warning</mat-icon>
    <span class="warning-text">{{ 'ENROLLMENT_COMPLETION.ENROLLMENT_IS_INCOMPLETE' | translate }}</span>
    <a (click)="emitSignatureRequest()" class="sign-now-link">{{ 'ENROLLMENT_COMPLETION.COMPLETE_ENROLLMENT' | translate }}</a>
  </div>
  <h3 class="email-address" *ngIf="shouldDisplayEmailAddress">
    <mat-icon class="account-icon" svgIcon="my-details"></mat-icon>
    {{ navbarToolbarContentService.emailAddress$ | async }}
  </h3>
  <mat-spinner *ngIf="navbarToolbarContentService.isLoading$ | async" class="spinner" diameter="40"></mat-spinner>
</div>
